import { useEffect, useState } from 'react';

/**
 * Hook that forces a component to rerender periodically using an internal timer.
 * Returns a tick counter that increments every interval.
 * Default: 2 seconds.
 */
export function useForceRerender(intervalMs: number = 2000): number {
    const [tick, setTick] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setTick(t => t + 1);
        }, intervalMs);

        return () => clearInterval(interval);
    }, [intervalMs]);

    return tick;
}
